import { AuthContext } from "../Context/AuthContext";
import { useContext } from "react";

const StringToColor = () => {
  const { getUserName } = useContext(AuthContext);
  const username = getUserName()
  function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = "#";

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }
  const child = username.trim().split(' ').map(word => word[0]).join('');
  return {
    sx: {
      bgcolor: stringToColor(username),
      height: "27px",
      width: "30px",
      alignItems: "center",
      paddingBottom: "3px",
    },
    children: `${child}`,
  };
};

export default StringToColor;
